/**
 * Semaine type lun–dim + dates civil Casablanca (aligné Todos / livraisons).
 */

export const TZ_CASA = 'Africa/Casablanca';

export function todayYMD() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CASA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(new Date());
}

/** Normalise une date API → AAAA-MM-JJ (jour civil à Casablanca). */
export function toYMD(due) {
  if (due == null || due === '') return null;
  if (typeof due === 'string' && /^\d{4}-\d{2}-\d{2}/.test(due.trim())) return due.trim().slice(0, 10);
  const d = new Date(due);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CASA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(d);
}

function startOfWeekMonday(d) {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const day = x.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  x.setDate(x.getDate() + diff);
  return x;
}

function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function parseYmd(ymd) {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/** 7 jours (lun–dim) à partir du lundi de la semaine contenant la date de référence. */
export function getWeekDays(weekOffset) {
  const base = parseYmd(todayYMD());
  base.setDate(base.getDate() + weekOffset * 7);
  const start = startOfWeekMonday(base);
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
}
